// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const DeveloperCommunity: MarkdocTagRegistration = {
  tag: 'developer-community',
  component: 'DeveloperCommunity',
};
